import styled, { css } from "styled-components";

export const ButtonBox = styled.div.attrs({ className: "button-box" })(({ theme, $variant = "primary" }) => css`
  padding: ${theme.buttons[`${$variant}`].padding};
  border: ${theme.buttons[`${$variant}`].border};
  background: ${theme.buttons[`${$variant}`].background};
  color: ${theme.buttons[`${$variant}`].color};
  border-radius: ${theme.buttons.borderRadius};
  cursor: pointer;
  min-width: 100px;
  text-align: center;
  margin: 12px auto 0;
  font-size: ${theme.buttons.fontSize};
  font-weight: ${theme.buttons.fontWeight};
  text-transform: ${theme.fonts.headingCase};
  transition: background 0.35s, color 0.35s;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  path {
    transition: 0.35s ease;
    fill: ${theme.buttons[`${$variant}`].color};
  }
  

  @media (hover: hover) {
    &:hover {
      background: ${theme.buttons[`${$variant}`].backgroundHover};
      color: ${theme.buttons[`${$variant}`].colorHover};

      path {
        fill: ${theme.buttons[`${$variant}`].colorHover};
      }

    }
  }

  @media only screen and (min-width: ${theme.breakpoints.S}) {
    min-width: 156px;
  }

  .button-icon-right {
    margin-left: 18px;
  }

  .button-icon-left {
    margin-right: 18px;
  }

  &:disabled, &.disabled {
    color: ${theme.buttons.disabled.color};
    background-color: ${theme.buttons.disabled.background};
    border: ${theme.buttons.disabled.border};
    cursor: auto;
    pointer-events: none;

    path {
      fill: ${theme.buttons.disabled.color};
    }

    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.disabled.color};
        background-color: ${theme.buttons.disabled.background};

        path {
          fill: ${theme.buttons.disabled.color};
        }
      }
    }
  }
`);

export const UnStyledButton = styled(ButtonBox).attrs((props) => ({
  as: props.$elementType ?? "button"
}))`
 
`;


export const StyledButton = styled(ButtonBox).attrs((props) => ({
  as: props.$elementType ?? "button"
}))`
  
`;
